import { Symbols } from '@ioc/symbols'
import { inject, injectable } from 'inversify'

import { QuotaErrorCode, QuotaMessage } from '@domain/quota-errors'

import { SessionStore } from '@infrastructure/stores/session/session-store'

import { TrackingManager } from '../tracking/tracking-manager'
import { Message, MessageType, buildMessages, buildQuotaMessages } from './messages'

@injectable()
export class MessageManager {
  constructor(
    @inject(SessionStore) private readonly sessionStore: SessionStore,
    @inject(TrackingManager) private readonly trackingManager: TrackingManager,
    @inject(Symbols.ENVIRONMENT) private readonly environment: ImportMetaEnv,
  ) {}

  public getQuotaMessage(): QuotaMessage {
    const quotaErrorCode = this.getQuotaErrorCode()
    const messages = buildQuotaMessages(this.environment, this.trackingManager)
    const message = messages[quotaErrorCode]
    return {
      message,
      code: quotaErrorCode,
    }
  }

  public getMessage(code: MessageType): Message | undefined {
    const messages = buildMessages(this.environment, this.trackingManager)
    const message = messages[code]

    if (!message) {
      return undefined
    }

    return message
  }

  public getDefaultMessage(): Message {
    return this.getMessage('default')!
  }

  private getQuotaErrorCode(): QuotaErrorCode {
    const user = this.sessionStore.getState().user
    if (!user) {
      return 'error-hit-limit-anonymous'
    }
    if (user.premium) {
      return 'error-hit-limit-premium'
    }
    return 'error-hit-limit-freemium'
  }
}
